import Vue from 'vue';
import Router from 'vue-router';
import { Toast } from 'vant';
import { isAuthenticated, isTokenExpired, removeToken } from '@/utils/request';
import { connectUserSocket, disconnectUserSocket } from '@/utils/socket';
import { resetPageScroll } from '@/utils/scroll';

Vue.use(Router);

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

const WHITE_LIST = ['/login'];

const router = new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 });
            }, 0);
        });
    },
    routes: [        {
            path: '/',
            redirect: '/uc/index',
        },
        {
            path: '/login',
            name: '登录',
            component: () => import('@/pages/Login'),
            meta: { public: true },
        },
        {
            path: '/uc/index',
            name: '个人中心',
            component: () => import('@/pages/ucenter/Index'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/LottoList',
            name: '开奖结果',
            component: () => import('@/pages/ucenter/LottoList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/TrendList',
            name: '走势',
            component: () => import('@/pages/ucenter/TrendList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/BetRecordList',
            name: '下注记录',
            component: () => import('@/pages/ucenter/BetRecordListPage.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/PredictList',
            name: '预测',
            component: () => import('@/pages/ucenter/PredictList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/FlowList',
            name: '账户流水',
            component: () => import('@/pages/ucenter/FlowList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/ChangePassword',
            name: '修改密码',
            component: () => import('@/pages/ucenter/ChangePassword.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/ReportList',
            name: '统计报表',
            component: () => import('@/pages/ucenter/ReportList.vue'),
            meta: { requiresAuth: true },
        },
        {
            path: '/uc/GameRules',
            name: '玩法规则',
            component: () => import('@/pages/ucenter/GameRules.vue'),
            meta: { requiresAuth: true },
        },
    ],
});

router.beforeEach((to, from, next) => {
    const authed = isAuthenticated();

    if (to.path === '/login' || to.meta.public) {
        if (authed) {
            next({ path: '/uc/index', replace: true });
            return;
        }
        disconnectUserSocket();
        next();
        return;
    }

    if (WHITE_LIST.includes(to.path)) {
        next();
        return;
    }

    if (!authed) {
        const message = isTokenExpired()
            ? '登录已过期，请重新登录'
            : '请先登录';
        removeToken();
        Toast.fail(message);
        next({
            path: '/login',
            query: { redirect: to.fullPath },
            replace: true,
        });
        return;
    }

    connectUserSocket();
    next();
});

router.afterEach(() => {
    resetPageScroll();
    setTimeout(resetPageScroll, 0);
    requestAnimationFrame(resetPageScroll);
});
export default router;
